<script setup>
import { useElfsight } from '@/Composables/useElfsight'

useElfsight()
</script>

<template>
	<div class="py-8">
		<div
			class="elfsight-app-e434b4ea-0a94-49a3-a736-2825a883e650"
			data-elfsight-app-lazy
		/>
	</div>
</template>
